'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.contactLinkWidget = function (config, navigatorShim) {
	return mmWidgets.each(this, function () {
		const element = this,
			isMailto = /^mailto:/i.test(config.contactLink);
		if (element.is('A')) {
			element.attr('href', config.contactLink);
			if (!isMailto) {
				element.attr('target', '_blank').on('click', function () {
					navigatorShim.popup(config.contactLink);
					return false;
				});
			}
		} else {
			element.on('click', function () {
				if (isMailto) {
					navigatorShim.locationReplace(config.contactLink);
				} else {
					navigatorShim.popup(config.contactLink);
				}
			});
		}
	});
};
